import { Button, CircularProgress, Grid, Icon } from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import React, { useCallback, useEffect } from 'react';
import { useObservable } from 'react-use-observable';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import leadsService from 'v2/services/leads/list';
import tableService from 'v2/services/table';

import initialValues from './initialValues';
import { useStyles } from './styles';

import type { FormikProps } from 'formik';

const leadTypes = [
  {
    label: 'Todos',
    value: '',
  },
  {
    label: 'Abandono de carrinho',
    value: true,
  },
  {
    label: 'Clicou em comprar',
    value: false,
  },
];

const Filter = () => {
  const classes = useStyles();
  useEffect(() => {
    leadsService.loadAffiliates();
    leadsService.loadCampaigns();
  }, []);

  const [isLoading] = useObservable(() => tableService.isLoading(), []);

  const [affiliates] = useObservable(() => leadsService.getAffiliates(), []);

  const [campaigns] = useObservable(() => leadsService.getCampaigns(), []);

  const onSubmit = useCallback((values: typeof initialValues, { setSubmitting }: FormikProps<typeof initialValues>) => {
    leadsService.setFilter({ ...values });
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ isValid, isSubmitting, dirty, resetForm }: FormikProps<typeof initialValues>) => (
        <Form id='leads-filter' data-testid='leads-filter' className={classes.root}>
          <div>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={4} xl={2}>
                <Field label='Período' id='date' name='date' component={DateRangePickerFormField} />
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={2}>
                <Field id='product_id' name='product_id' fullWidth hasLabel endpoint='/reports/leads/products' component={SelectProduct} />
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={2}>
                <Field id='affiliate_id' name='affiliate_id' multiple options={affiliates} fullWidth label='Afiliados' component={SelectFormField} />
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={2}>
                <Field id='campaign_id' name='campaign_id' multiple options={campaigns} fullWidth label='Campanhas' component={SelectFormField} />
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={2}>
                <Field id='abandonment' name='abandonment' options={leadTypes} fullWidth label='Tipo de lead' component={SelectFormField} />
              </Grid>
              <Grid item xs={12} md={2} xl={1} className={classes.buttonContainer}>
                <Button
                  id='clear-button'
                  disabled={!dirty || isSubmitting || isLoading}
                  color='primary'
                  fullWidth
                  onClick={() => resetForm({ values: initialValues })}
                >
                  <span id='clear-button-label'>Limpar</span>
                  {(isLoading || isSubmitting) && <CircularProgress size={10} style={{ color: '#192542', marginLeft: 10 }} />}
                </Button>
              </Grid>
              <Grid item xs={12} md={2} xl={1} className={classes.buttonContainer}>
                <Button
                  id='basic-filter-button'
                  variant='contained'
                  disabled={!isValid || isSubmitting || isLoading}
                  color='secondary'
                  fullWidth
                  type='submit'
                >
                  <Icon id='basic-filter-button-icon' style={{ marginRight: '0.5rem', fontSize: 14 }}>
                    filter_list
                  </Icon>{' '}
                  <span id='basic-filter-button-label'>Filtrar</span>
                  {(isLoading || isSubmitting) && <CircularProgress size={10} style={{ color: '#192542', marginLeft: 10 }} />}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Form>
      )}
    </Formik>
  );
};
export default Filter;
